import React from 'react';
import { DateTime } from 'luxon';
import { useInterval } from 'usehooks-ts';

export default function CurrentTime() {
  const [label, setLabel] = React.useState(
    DateTime.now().toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY),
  );

  useInterval(() => {
    const value = DateTime.now().toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY);
    setLabel(value);
  }, 1000);

  return (
    <div className="text-muted mb-16 time-attendance-current-time">
      {label}
    </div>
  );
}
